import presbyterian from "@/static/logos/presbyterian-logo-red.svg";
import eh from "@/static/logos/eh-logo.svg";
import favicon_php from "@/static/favicons/favicon-php.svg";
import favicon_eh from "@/static/favicons/favicon-eh.svg";

import judiHealth from "@/static/logos/judi-health-horizontal-white.png";
import stLukes from "@/static/logos/st-lukes-logo.png";
import favicon_st_lukes from "@/static/favicons/favicon-st-lukes.ico";

export interface ThemeConfig {
  clientDisplayName: string;
  logo?: {
    url: string;
    width?: string;
    height?: string;
  };
  banner_gradient?: string;
  primary_color?: string;
  favicon: {
    url?: string;
    width?: string;
    height?: string;
  };
  primary_hover_color: string;
  secondary_hover_color: string;
  header_text_color: string;
  showPA: boolean;
  showPharmacy: boolean;
  showPatient: boolean;
  showBilling: boolean;
  showMedicalClaims: boolean;
}


export interface ThemeMap {
  [key: string]: ThemeConfig;
}

export const THEMES: ThemeMap = {
  default: {
    clientDisplayName: "Judi Health",
    logo: {
      url: judiHealth,
      height: "24px",
      width: "144px",
    },
    banner_gradient: "linear-gradient(270deg, #44659E 0%, #395992 50.1%, #14316B 99.2%)",
    primary_color: "#0071B3",
    favicon: {},
    primary_hover_color: "#007ec7",
    secondary_hover_color: "#0085d2",
    header_text_color: "#FFFFFF",
    showPA: true,
    showPharmacy: true,
    showPatient: true,
    showBilling: true,
    showMedicalClaims: true,
  },
  presbyterian: {
    clientDisplayName: "Presbyterian",
    logo: {
      url: presbyterian,
      width: "225px",
      height: "30px",
    },
    banner_gradient: "linear-gradient(270deg, #D4203D 0%, #A71930 50%, #891527 100%)",
    primary_color: "#A71930",
    favicon: {
      url: favicon_php,
      width: "22",
      height: "25",
    },
    primary_hover_color: "#891527",
    secondary_hover_color: "#A71930",
    header_text_color: "#FFFFFF",
    showPA: true,
    showPharmacy: true,
    showPatient: true,
    showBilling: true,
    showMedicalClaims: false,
  },
  emblem: {
    clientDisplayName: "Emblem Health",
    logo: {
      url: eh,
      width: "225px",
      height: "30px",
    },
    banner_gradient: "linear-gradient(270deg, #EBE2F5 0%, #EBE2F5 50%, #EBE2F5 100%)",
    primary_color: "#490E67",
    favicon: {
      url: favicon_eh,
      width: "22px",
      height: "25px",
    },
    primary_hover_color: "#661C8C",
    secondary_hover_color: "#75299C",
    header_text_color: "#490E67",
    showPA: true,
    showPharmacy: true,
    showPatient: true,
    showBilling: true,
    showMedicalClaims: false,
  },
  prime: {
    clientDisplayName: "Emblem Health",
    logo: {
      url: eh,
      width: "225px",
      height: "30px",
    },
    banner_gradient: "linear-gradient(270deg, #EBE2F5 0%, #EBE2F5 50%, #EBE2F5 100%)",
    primary_color: "#490E67",
    favicon: {
      url: favicon_eh,
      width: "22px",
      height: "25px",
    },
    primary_hover_color: "#661C8C",
    secondary_hover_color: "#75299C",
    header_text_color: "#490E67",
    showPA: true,
    showPharmacy: false,
    showPatient: false,
    showBilling: false,
    showMedicalClaims: false,
  },
  "st-lukes": {
    clientDisplayName: "St Luke's Health Plan",
    logo: {
      url: stLukes,
      width: "133px",
      height: "50px",
    },
    banner_gradient: "linear-gradient(270deg, #0057B8 100%, #0057B8 100%, #0057B8 100%)",
    primary_color: "#0057B8",
    favicon: {
      url: favicon_st_lukes,
      width: "22px",
      height: "25px",
    },
    primary_hover_color: "#10427B",
    secondary_hover_color: "#0076BB",
    header_text_color: "#FFFFFF",
    showPA: true,
    showPharmacy: false,
    showPatient: false,
    showBilling: false,
    showMedicalClaims: false,
  },
};
